import { Pipe, PipeTransform } from '@angular/core';
import { DateHelperService } from '../services';

@Pipe({
  name: 'ddMMYYYY'
})
export class DdMMYYYYPipe implements PipeTransform {
  constructor(private date: DateHelperService) {}
  transform(value: any, ...args: any[]): any {
    if (value) {
      if (Array.isArray(value)) {
        return value.map(e => this.date.convertDate(e, args[0]));
      }
      return this.date.convertDate(value, args[0]);
    }
    return value;
  }
}
